import React, { useCallback, useContext, useEffect, useState } from "react";

import Accordion from "../../components/Accordions/Accordion";
import CalendarTariff from "mg-calendar-tariff/dist";
import { DesignProgramContext } from "../CustomHooks/ContextApi";
import LoadShedding from "../DesignPrograms/LoadShedding"
import embLabels from "../../config/emb-labels-en.json";
import isTouchDevice from "../SE-Component/Tooltip";
import LABEL_VALIDATIONS from "../../config/LABEL_VALIDATIONS.json";
import LABELS from "../../config/LABELS.json";
import moment from "moment";
import _ from "lodash";
import Tooltip from "../../utils/Tooltip";
import { useSelector } from "react-redux";
import { getProject, getProjectTypeValue } from "../../utils/project";
import useProjectTypeValue from "../../utils/useCurrentProjectValue";
import DevicePriority from "../../components/DevicePriority";
import UtilityBillingContract from "../../components/BillingContract/UtilityBillingContract";
import DemandLimitCalculation from "../../components/DemandLimitCalculation/DemandLimitCalculation";

const OnGridOptimization = () => {
  const {
    clientType,
    gridSettings,
    isRealTimeExportConfg,
    isMotorizedOrContactor,
    configuredStatus,
    demandChargeOutput,
    siteType,
    maxExportPower,
    peakImportHysteresis,
    maxLimitEnergyExportPower,
    maxLimitEnergyImportPower,
    importStartHysteresis,
    importStopHysteresis,
    batteryDetails,
    pvCurtailmentExport,
    lossOfComm,
    lossOfCommEMA,
    utilityLSIEnable,
    templateSelected,
    architectureType,
    demandChargeDataCallback,
    tariffDynamicConfiguration,
    handleDynamicTariffConfiguration,
    exportManagementChange,
    configuredStatusModified,
    handleChange,
    handleCheckBoxChange,
    handlepPVOpeningPopup,
    enableTemplatePopUp,
    isBessOperatingMode,
    exportManagementBessMode,
    refresh,
    validateProgram,
    validResultFunc,
    siteCreated,
    projectStatusData,
    UserScope,
    sellTariff,
    deltaSellTariff,
    handleLimitExportImportOptimization,
    limitExport,
    limitImport,
    currency,
    defaultDynamicTariff,
    demandChargeUseCaseSelection,
    eVceData,
    evMaxAllowedPower,
    handleEVCE,
    handleBillingCycle,
    billingPeriod,
    handleDcthreshold,
    dcthreshold,
    handleDcThresholdCustomMonth,
    dcthresholdCustomMonthErrors,
    updateUtilityDates,
    generateDefaultData,
    
  } = useContext(DesignProgramContext);
  const projectTypeValue = useProjectTypeValue();
 const isGridSiteWithImportLimitationTrue = limitImport && (siteType === "GRID_CONNECTED" && (["MGaaS ANSI", "MGaaS IEC", "MGaaS ETO"].includes(projectTypeValue)));
  const projectKind = getProject();
  const tooltipData = useSelector((state) => state?.tooltipData?.tooltipData);
  const [alertPopup, setAlertPopup] = useState({
    message: "",
    alertPopUpStatus: false,
    title: "Alert",
  });
  useEffect(() => {
    const observer = new MutationObserver((mutationsList) => {
      let getFDCelementradio = document.getElementById("fdcType");
      const getFDCelement = document.getElementById("use-case-fdc");
      if (
        getFDCelement &&
        projectTypeValue.includes("ANSI") &&
        getFDCelementradio
      ) {
        if (
          getFDCelement &&
          getFDCelement?.style &&
          getFDCelementradio?.parentElement
        ) {
          getFDCelement.style.cursor = "not-allowed";
          getFDCelementradio.parentElement.style.pointerEvents = "none";
          getFDCelementradio.style.cursor = "not-allowed";
        }
      }
      const allowDisable =
        projectTypeValue.includes("ANSI") || projectTypeValue.includes("IEC");
      if (allowDisable) {
        for (let mutation of mutationsList) {
          if (mutation.type === "childList" || mutation.type === "attributes") {
            const selectElement = document.querySelector(
              'select.custom-select[name="penaltyCalculation"]'
            );
            if (selectElement) {
              const usOption = selectElement.querySelector(
                `option[value=${
                  projectTypeValue.includes("ANSI") ? "PORTUGUESE" : "US"
                }]`
              );

              if (usOption) {
                usOption.style.display = "none";
              }
              break;
            }
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);
  const closeAlertPopup = useCallback(() => {
    setAlertPopup({
      message: "",
      alertPopUpStatus: false,
      title: "",
    });
  }, [alertPopup]);
  const exportManagementChangeHandler = () => {
    exportManagementChange();
    configuredStatusModified("emConfiguredStatus");
  };

  const maxExportImportPowerChangeHandler = (e) => {
    handleChange(e);
    configuredStatusModified("emConfiguredStatus");
  };

  const exportFunctionChangeHandler = (e) => {
    const { name, id } = e.target;
    if (
      isMotorizedOrContactor?.isPvCBsMotorizedOrContactor  === false &&
      id === "isPvCBsMotorizedOrContactor"
    ) {
      setAlertPopup({
        message:
          "To be able to ensure circuit breaker operation, please update DER configuration by adding motor mechanism or circuit breaker to PV branches and/or BESS branches.",
        alertPopUpStatus: true,
        title: "Alert",
      });
    }else  if (
      isMotorizedOrContactor?.isBessCBsMotorizedOrContactor  === false &&
      id === "isBessCBsMotorizedOrContactor"
    ) {
      setAlertPopup({
        message:
          "To be able to ensure circuit breaker operation, please update DER configuration by adding motor mechanism or circuit breaker to PV branches and/or BESS branches.",
        alertPopUpStatus: true,
        title: "Alert",
      });
    }
     else {
      handleCheckBoxChange(e);
      configuredStatusModified("emConfiguredStatus");
    }
  };

  const utilityLSIChangeHandler = (e) => {
    const { name, id } = e.target;
    if (
      isMotorizedOrContactor?.isPvCBsMotorizedOrContactor === false &&
      id === "isBessCBsMotorizedOrContactor"
    ) {
      setAlertPopup({
        message:
          "To be able to ensure circuit breaker operation, please update DER configuration by adding motor mechanism or circuit breaker to PV branches and/or BESS branches",
        alertPopUpStatus: true,
        title: "Alert",
      });
    } else {
      configuredStatusModified("emConfiguredStatus");
      handlepPVOpeningPopup(e);
    }
  };

  const hysteresisChangeHandler = (e) => {
    handleChange(e);
    configuredStatusModified("realTimeControlEMA");
  };

  const getTooltipDataImportPower  = () =>{
    const tooltip =  tooltipData?.limitEnergyImportTooltipData?.data?.split('\\');
    return tooltip;
  }

  return (
    <>
      {(gridSettings?.noExport === true ||
        gridSettings?.exportOptimization === true ||
        gridSettings?.tariffManagement === true ||
        gridSettings?.selfConsumption === true ||
        gridSettings?.demandCharge === true ||
        gridSettings?.manualDemandResponse === true ||
        gridSettings?.greenConsumption === true ||
        gridSettings?.netMetering === true ||
        gridSettings?.bessEnergyExchanges === true ||
        gridSettings?.bessEnergyExchanges === false) && (
        <div
          className={`row se-white-background pb-2 ${
            !UserScope.access.saveProgram ? "se-block-disabled" : ""
          }`}
        >
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-2 ">
            <span className="se-font-14px-bold se-life-green ">
              Energy Optimization
            </span>

            <div className="row ">
              {gridSettings?.noExport === false &&
              gridSettings?.exportOptimization === false &&
              gridSettings?.tariffManagement === false &&
              gridSettings?.selfConsumption === false &&
              gridSettings?.demandCharge === false &&
              gridSettings?.manualDemandResponse === false &&
              gridSettings?.noImport === false &&
              gridSettings?.greenConsumption === false &&
              gridSettings?.netMetering === false &&
              !(
                gridSettings?.bessEnergyExchanges === true ||
                gridSettings?.bessEnergyExchanges === false
              ) ? (
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div className="row">
                    <label className="col-md-7 col-form-label pl-5">
                      No on-grid optimization usecase
                    </label>
                  </div>
                </div>
              ) : (
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <Accordion allowMultipleOpen>
                    <div
                      className="col-md-12"
                      label="Demand Charge and Time of Use Tariff "
                      status={
                        configuredStatus.dcConfiguredStatus === 1 ||
                        configuredStatus.dynamicConfiguredStatus === 1 ||
                        configuredStatus.sellTariffConfiguredStatus === 1
                          ? 1
                          : configuredStatus.dcConfiguredStatus === 2 ||
                            configuredStatus.dynamicConfiguredStatus === 2 ||
                            configuredStatus.sellTariffConfiguredStatus === 2
                          ? 2
                          : 0
                      }
                      displayStatus={
                        gridSettings?.demandCharge === true ||
                        gridSettings?.tariffManagement === true
                          ? "1"
                          : "0"
                      }
                      icon="notification_error_full_stroke"
                      enableTemplatePopUp={enableTemplatePopUp}
                    >
                      <div className="row p-3">
                        <Accordion allowMultipleOpen>
                          <div
                            className={`col-md-12 `}
                            label=" Static Tariff Configuration"
                            status={configuredStatus.dcConfiguredStatus}
                            displayStatus="1"
                            icon="notification_error_full_stroke"
                            enableTemplatePopUp={enableTemplatePopUp}
                          >
                            <div
                              className={`${
                                siteCreated ||
                                projectStatusData?.projectStatus ===
                                  "COMPLETED" ||
                                projectStatusData?.projectStatus ===
                                  "COMPLETED_AND_SEND"
                                  ? "se-block-disabled not-allowed"
                                  : !UserScope.access.saveProgram
                                  ? "se-block-disabled"
                                  : ""
                              }`}
                            >
                              <CalendarTariff
                                lastSubmit={refresh}
                                validResult={validResultFunc}
                                demandChargeData={demandChargeOutput}
                                currency={currency?.symbol}
                                draftCallback={demandChargeDataCallback}
                                demandChargeUseCase={gridSettings?.demandCharge}
                                timeOfUseCase={gridSettings?.tariffManagement}
                                customLabels={LABELS}
                                weekdayLabels={_.map(
                                  [1, 2, 3, 4, 5, 6, 0],
                                  (day) => moment.weekdays()[day]
                                )}
                                templateSel={templateSelected}
                                VALIDATION_LABELS={LABEL_VALIDATIONS}
                              ></CalendarTariff>
                            </div>
                          </div>
                       { ["DaaS ANSI", "MGaaS ANSI"].includes(projectKind?.projectTypeValue ) && (demandChargeUseCaseSelection === "DCMP") &&
                        <div
                            className={`col-md-12 `}
                            label="Utility Billing Contract"
                            status={1}
                            displayStatus="1"
                            icon="notification_error_full_stroke"
                          >
                            <div
                             
                            >
                          {  billingPeriod &&  <UtilityBillingContract 
                              handleBillingCycle = {handleBillingCycle}
                              billingPeriod = {billingPeriod}
                              dcthresholdCustomMonthErrors ={dcthresholdCustomMonthErrors}
                              updateUtilityDates = {updateUtilityDates}
                              dcthreshold = {dcthreshold}
                              projectStatusData = {projectStatusData}
                              siteCreated = {siteCreated}
                              />}
                            </div>
                          </div>
                        }
                   { ["DaaS ANSI", "MGaaS ANSI"].includes(projectKind?.projectTypeValue ) && (demandChargeUseCaseSelection === "DCMP") && 
                        <div
                            className={`col-md-12 `}
                            label="DC threshold preset configuration"
                            status={1}
                            displayStatus="1"
                            icon="notification_error_full_stroke"
                          >
                            <div
                              className={` col-md-12 ${
                                siteCreated ||
                                projectStatusData?.projectStatus ===
                                  "COMPLETED" ||
                                projectStatusData?.projectStatus ===
                                  "COMPLETED_AND_SEND"
                                  ? "se-block-disabled not-allowed"
                                  : !UserScope.access.saveProgram
                                  ? "se-block-disabled"
                                  : ""
                              }`}
                            >
                             <DemandLimitCalculation 
                             handleDcthreshold = {handleDcthreshold}
                             dcthreshold = {dcthreshold}
                             handleDcThresholdCustomMonth = {handleDcThresholdCustomMonth}
                             dcthresholdCustomMonthErrors = {dcthresholdCustomMonthErrors}
                             generateDefaultData = {generateDefaultData}
                             />
                            </div>
                          </div>
                        }
                          {!["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes(
                            projectKind?.projectTypeValue
                          ) && (
                            <div
                              className={`col-md-12 mt-2 `}
                              label=" Dynamic Tariff Configuration"
                              status={configuredStatus.dynamicConfiguredStatus}
                              displayStatus="1"
                              icon="notification_error_full_stroke"
                              enableTemplatePopUp={enableTemplatePopUp}
                            >
                              <div
                                className={`col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 ${
                                  siteCreated ||
                                  projectStatusData?.projectStatus ===
                                    "COMPLETED" ||
                                  projectStatusData?.projectStatus ===
                                    "COMPLETED_AND_SEND"
                                    ? "se-block-disabled not-allowed"
                                    : !UserScope.access.saveProgram
                                    ? "se-block-disabled"
                                    : ""
                                }`}
                              >
                                <div className="row">
                                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 ">
                                    <div className="row pl-3">
                                      <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                        <div className="custom-control custom-radio">
                                          <input
                                            type="radio"
                                            id="none"
                                            name="tariffType"
                                            className="custom-control-input islandableRadio  asCompatible"
                                            checked={
                                              tariffDynamicConfiguration ===
                                              null
                                            }
                                            onClick={
                                              handleDynamicTariffConfiguration
                                            }
                                            value="null"
                                          />
                                          <label
                                            className="custom-control-label line-height-25px"
                                            htmlFor="none"
                                          >
                                            None
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                        <div className="custom-control custom-radio">
                                          <input
                                            type="radio"
                                            id="dayTariff24hHours"
                                            name="tariffType"
                                            className="custom-control-input islandableRadio  asCompatible"
                                            checked={
                                              tariffDynamicConfiguration?.tariffType ===
                                              "dynamic"
                                            }
                                            onClick={
                                              handleDynamicTariffConfiguration
                                            }
                                            value="dynamic"
                                          />
                                          <label
                                            className="custom-control-label line-height-25px"
                                            htmlFor="dayTariff24hHours"
                                          >
                                            24 hour day ahead Tariff
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                        <div className="custom-control custom-radio">
                                          <input
                                            type="radio"
                                            id="spotPrice"
                                            name="tariffType"
                                            className="custom-control-input islandableRadio  asCompatible"
                                            checked={
                                              tariffDynamicConfiguration?.tariffType ===
                                              "spotPrice"
                                            }
                                            onClick={
                                              handleDynamicTariffConfiguration
                                            }
                                            value="spotPrice"
                                          />
                                          <label
                                            className="custom-control-label line-height-25px"
                                            htmlFor="omieSpain"
                                          >
                                            Spot Price
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {tariffDynamicConfiguration?.tariffType ===
                                    "dynamic" && (
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 mt-2">
                                      <div className="row pl-3">
                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                          <span className="bold ">
                                            Select Platform :
                                          </span>
                                        </div>
                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ">
                                          <div className="row pl-4">
                                            <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                              <div className="custom-control custom-radio">
                                                <input
                                                  type="radio"
                                                  id="omieBasedTariff"
                                                  name="platform"
                                                  className="custom-control-input islandableRadio  asCompatible"
                                                  checked={
                                                    tariffDynamicConfiguration
                                                      ?.dynamicHourTariff
                                                      ?.platformType === "omie"
                                                  }
                                                  onClick={
                                                    handleDynamicTariffConfiguration
                                                  }
                                                  value="omie"
                                                />
                                                <label
                                                  className="custom-control-label line-height-25px"
                                                  htmlFor="omieBasedTariff"
                                                >
                                                  OMIE based tariff
                                                </label>
                                              </div>
                                            </div>
                                            <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                              <div className="custom-control custom-radio">
                                                <input
                                                  type="radio"
                                                  id="epexBasedTariff"
                                                  name="platform"
                                                  className="custom-control-input islandableRadio  asCompatible"
                                                  checked={
                                                    tariffDynamicConfiguration
                                                      ?.dynamicHourTariff
                                                      ?.platformType === "epex"
                                                  }
                                                  onClick={
                                                    handleDynamicTariffConfiguration
                                                  }
                                                  value="epex"
                                                />
                                                <label
                                                  className="custom-control-label line-height-25px"
                                                  htmlFor="epexBasedTariff"
                                                >
                                                  EPEX based tariff
                                                </label>
                                              </div>
                                            </div>
                                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                              <div className="row">
                                                {(tariffDynamicConfiguration
                                                  ?.dynamicHourTariff
                                                  ?.platformType === "omie" ||
                                                  tariffDynamicConfiguration
                                                    ?.dynamicHourTariff
                                                    ?.platformType ===
                                                    "epex") && (
                                                  <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mt-2 ">
                                                    <span className="bold ">
                                                      Select Region :
                                                    </span>
                                                  </div>
                                                )}
                                                {tariffDynamicConfiguration
                                                  ?.dynamicHourTariff
                                                  ?.platformType === "omie" && (
                                                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ">
                                                    <div className="form-group row ">
                                                      <label
                                                        htmlFor="region"
                                                        className="col-sm-2 col-md-2 col-form-label text-right "
                                                      >
                                                        Countries
                                                      </label>

                                                      <div className="col-sm-3">
                                                        <select
                                                          className="col-sm-12 col-lg-12 col-md-12 col-xl-12  form-control form-control-sm"
                                                          name="country"
                                                          id="platformDayAhead"
                                                          value={
                                                            tariffDynamicConfiguration
                                                              ?.dynamicHourTariff
                                                              ?.platformDayAhead
                                                          }
                                                          onChange={
                                                            handleDynamicTariffConfiguration
                                                          }
                                                        >
                                                          <option
                                                            value=" "
                                                            disabled
                                                            selected
                                                            hidden
                                                          >
                                                            Select countries
                                                          </option>
                                                          {defaultDynamicTariff?.tariffTypeList?.[
                                                            "24-Hour Day Ahead Tariff"
                                                          ]?.[0]?.["OMIE"]?.map(
                                                            (region) => (
                                                              <option
                                                                key={region}
                                                                value={region}
                                                              >
                                                                {region}
                                                              </option>
                                                            )
                                                          )}
                                                        </select>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                                {tariffDynamicConfiguration
                                                  ?.dynamicHourTariff
                                                  ?.platformType === "epex" && (
                                                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                                                      <div className="form-group row ">
                                                        <label
                                                          htmlFor="area"
                                                          className="col-sm-2 col-md-2 col-form-label text-right "
                                                        >
                                                          Market Area
                                                        </label>

                                                        <div className="col-sm-3">
                                                          <select
                                                            className="col-sm-12 col-lg-12 col-md-12 col-xl-12  form-control form-control-sm"
                                                            name="area"
                                                            id="area"
                                                            value={
                                                              tariffDynamicConfiguration
                                                                ?.dynamicHourTariff
                                                                ?.platformDayAhead
                                                            }
                                                            onChange={
                                                              handleDynamicTariffConfiguration
                                                            }
                                                          >
                                                            <option
                                                              value=" "
                                                              disabled
                                                              selected
                                                              hidden
                                                            >
                                                              Select market area
                                                            </option>
                                                            {defaultDynamicTariff?.tariffTypeList?.[
                                                              "24-Hour Day Ahead Tariff"
                                                            ]?.[1]?.[
                                                              "EPEX"
                                                            ]?.map((area) => (
                                                              <option
                                                                key={area}
                                                                value={area}
                                                              >
                                                                {area}
                                                              </option>
                                                            ))}
                                                          </select>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {tariffDynamicConfiguration?.tariffType ===
                                    "spotPrice" && (
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 mt-2">
                                      <div className="row pl-3">
                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                          <span className="bold">
                                            Select Platform :{" "}
                                          </span>
                                        </div>
                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                          <div className="row pl-3">
                                            <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                              <div className="custom-control custom-radio">
                                                <input
                                                  type="radio"
                                                  id="AEMOBasedTariff"
                                                  name="platformSpotPrice"
                                                  className="custom-control-input islandableRadio  asCompatible"
                                                  checked={
                                                    tariffDynamicConfiguration
                                                      ?.spotPriceTariff
                                                      ?.platformSpotPrice ===
                                                    "aemo"
                                                  }
                                                  onClick={
                                                    handleDynamicTariffConfiguration
                                                  }
                                                  value="aemo"
                                                />
                                                <label
                                                  className="custom-control-label line-height-25px"
                                                  htmlFor="AEMOBasedTariff"
                                                >
                                                  AEMO based tariff
                                                </label>
                                              </div>
                                            </div>
                                            {tariffDynamicConfiguration
                                              ?.spotPriceTariff
                                              ?.platformSpotPrice ===
                                              "aemo" && (
                                              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1">
                                                <div className="form-group row ">
                                                  <label
                                                    htmlFor="scale"
                                                    className="col-sm-2 col-md-2 col-form-label text-right "
                                                  >
                                                    Scale
                                                  </label>

                                                  <div className="col-sm-3">
                                                    <input
                                                      type="text"
                                                      autoComplete="none"
                                                      className="form-control form-control-sm"
                                                      name="scale"
                                                      placeholder="Enter Scale"
                                                      maxLength="50"
                                                      value={
                                                        tariffDynamicConfiguration
                                                          ?.spotPriceTariff
                                                          ?.scale
                                                      }
                                                      onChange={
                                                        handleDynamicTariffConfiguration
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                                <div className="form-group row ">
                                                  <label
                                                    htmlFor="region"
                                                    className="col-sm-2 col-md-2 col-form-label text-right "
                                                  >
                                                    Region
                                                  </label>

                                                  <div className="col-sm-3">
                                                    <select
                                                      className="col-sm-12 col-lg-12 col-md-12 col-xl-12  form-control form-control-sm"
                                                      name="region"
                                                      id="region"
                                                      value={
                                                        tariffDynamicConfiguration
                                                          ?.spotPriceTariff
                                                          ?.region
                                                      }
                                                      onChange={
                                                        handleDynamicTariffConfiguration
                                                      }
                                                    >
                                                      {defaultDynamicTariff.tariffTypeList?.[
                                                        "Spot Price"
                                                      ]?.[0]?.["AEMO"].map(
                                                        (region) => (
                                                          <option
                                                            key={region}
                                                            value={region}
                                                          >
                                                            {region}
                                                          </option>
                                                        )
                                                      )}
                                                    </select>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                          {!["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes(
                            projectKind?.projectTypeValue
                          ) && (
                            <div
                              className="col-md-12 mt-2"
                              label=" Sell Tariff Configuration"
                              status={configuredStatus.sellTariffConfiguration}
                              displayStatus="1"
                              icon="notification_error_full_stroke"
                              enableTemplatePopUp={enableTemplatePopUp}
                            >
                              <div
                                className={`col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 ${
                                  siteCreated ||
                                  projectStatusData?.projectStatus ===
                                    "COMPLETED" ||
                                  projectStatusData?.projectStatus ===
                                    "COMPLETED_AND_SEND"
                                    ? "se-block-disabled not-allowed"
                                    : !UserScope.access.saveProgram
                                    ? "se-block-disabled"
                                    : ""
                                }`}
                              >
                                <div className="row">
                                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 ">
                                    <div className="row pl-3 mt-1">
                                      <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                        <div className="custom-control custom-radio">
                                          <input
                                            type="radio"
                                            id="sellTariff1"
                                            name="sellTariff"
                                            className="custom-control-input islandableRadio  asCompatible"
                                            checked={sellTariff === "at0"}
                                            onClick={
                                              handleDynamicTariffConfiguration
                                            }
                                            value="at0"
                                          />
                                          <label
                                            className="custom-control-label line-height-25px"
                                            htmlFor="sellTariff1"
                                          >
                                            Selling price equals zero
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                        <div className="custom-control custom-radio">
                                          <input
                                            type="radio"
                                            id="sellTariff2"
                                            name="sellTariff"
                                            className="custom-control-input islandableRadio  asCompatible"
                                            checked={sellTariff === "likeBuy"}
                                            onClick={
                                              handleDynamicTariffConfiguration
                                            }
                                            value="likeBuy"
                                          />
                                          <label
                                            className="custom-control-label line-height-25px"
                                            htmlFor="sellTariff2"
                                          >
                                            Selling price equals purchase price
                                            minus delta
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    {sellTariff === "likeBuy" && (
                                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 ">
                                        <div className="form-group row pl-3 mt-3">
                                          <label
                                            htmlFor="deltaSellTariff"
                                            className="col-sm-3 m-0"
                                          >
                                            {`Delta Sell Tariff ( ${currency?.symbol}/KWh )`}
                                            <se-tooltip position="right">
                                              <se-icon
                                                option="raised"
                                                color="secondary"
                                                slot="tooltip"
                                              >
                                                information_circle
                                              </se-icon>
                                              <se-tooltip-content>
                                                {` Delta value > 0 for sell price lower than buy price`}
                                              </se-tooltip-content>
                                            </se-tooltip>
                                          </label>

                                          <div className="col-sm-3">
                                            <input
                                              type="text"
                                              autoComplete="none"
                                              className="form-control form-control-sm"
                                              name="deltaSellTariff"
                                              placeholder="Enter delta sell tariff"
                                              maxLength="5"
                                              value={deltaSellTariff}
                                              onChange={
                                                handleDynamicTariffConfiguration
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </Accordion>
                      </div>
                    </div>

                    {[
                      embLabels.GRID_CONNECTED_GSX,
                      embLabels.ISLANDABLE_GSX,
                      embLabels.GRID_CONNECTED,
                      embLabels.ISLANDABLE,
                    ].includes(siteType) &&
                      (gridSettings?.bessEnergyExchanges === true ||
                        gridSettings?.bessEnergyExchanges === false) && (
                        <div
                          className="col-md-12"
                          label="BESS Operating Modes"
                          status={1}
                          displayStatus={"1"}
                          icon="notification_error_full_stroke"
                        >
                          <div
                            className={`col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-1 ${
                              siteCreated ||
                              projectStatusData?.projectStatus ===
                                "COMPLETED" ||
                              projectStatusData?.projectStatus ===
                                "COMPLETED_AND_SEND"
                                ? "se-block-disabled not-allowed"
                                : !UserScope.access.saveProgram
                                ? "se-block-disabled"
                                : ""
                            } `}
                          >
                            {/* {(projectTypeValue === "MGaaS IEC" ||
                              projectTypeValue === "MGaaS ETO") && (
                              <div className="row">
                                {
                                  // don't delete now,  will enable this in the coming features
                                  // !gridSettings?.bessEnergyExchanges &&

                                  <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-2 ">
                                    <div className="custom-control custom-radio">
                                      <input
                                        type="radio"
                                        id="customRadioDegraded1"
                                        name="bessMode"
                                        className="custom-control-input islandableRadio  asCompatible"
                                        checked={
                                          isBessOperatingMode === "UNRESTRICTED"
                                        }
                                        onClick={exportManagementBessMode}
                                        value="UNRESTRICTED"
                                      />
                                      <label
                                        className="custom-control-label line-height-25px"
                                        htmlFor="customRadioDegraded1"
                                      >
                                        UNRESTRICTED
                                      </label>
                                      <se-tooltip
                                        action={
                                          true
                                            ? isTouchDevice()
                                              ? "click"
                                              : "hover"
                                            : ""
                                        }
                                        position="right"
                                      >
                                        <se-icon
                                          option="raised"
                                          color="secondary"
                                          slot="tooltip"
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content>
                                          "BESS can charge from grid and PV.
                                          BESS can discharge to grid"
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </div>
                                  </div>
                                }

                                {gridSettings?.bessEnergyExchanges  && (
                                  <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-2 ">
                                    <div className="custom-control custom-radio">
                                      <input
                                        type="radio"
                                        id="customRadioDegraded2"
                                        name="bessMode"
                                        className="custom-control-input islandableRadio  asCompatible"
                                        checked={
                                          isBessOperatingMode === "EXPORT_ONLY"
                                        }
                                        onClick={exportManagementBessMode}
                                        value="EXPORT_ONLY"
                                      />
                                      <label
                                        className="custom-control-label line-height-25px"
                                        htmlFor="customRadioDegraded2"
                                      >
                                        EXPORT ONLY
                                      </label>
                                      <se-tooltip
                                        action={
                                          true
                                            ? isTouchDevice()
                                              ? "click"
                                              : "hover"
                                            : ""
                                        }
                                        position="right"
                                      >
                                        <se-icon
                                          option="raised"
                                          color="secondary"
                                          slot="tooltip"
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content>
                                          "BESS cannot charge from grid. It can
                                          only charge from PV production. BESS
                                          can discharge to grid"
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </div>
                                  </div>
                                )}

                                {gridSettings?.bessEnergyExchanges  && (
                                  <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-2 ">
                                    <div className="custom-control custom-radio">
                                      <input
                                        type="radio"
                                        id="customRadioDegraded3"
                                        className="custom-control-input islandableRadio  asCompatible"
                                        name="bessMode"
                                        checked={
                                          isBessOperatingMode === "IMPORT_ONLY"
                                        }
                                        onClick={exportManagementBessMode}
                                        value="IMPORT_ONLY"
                                      />
                                      <label
                                        className="custom-control-label line-height-25px"
                                        htmlFor="customRadioDegraded3"
                                      >
                                        IMPORT ONLY
                                      </label>
                                      <se-tooltip
                                        action={
                                          true
                                            ? isTouchDevice()
                                              ? "click"
                                              : "hover"
                                            : ""
                                        }
                                        position="right"
                                      >
                                        <se-icon
                                          option="raised"
                                          color="secondary"
                                          slot="tooltip"
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content>
                                          "BESS can charge from grid and PV.
                                          BESS cannot discharge to grid"
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </div>
                                  </div>
                                )}
                                {gridSettings?.bessEnergyExchanges  && (
                                  <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-2 ">
                                    <div className="custom-control custom-radio">
                                      <input
                                        type="radio"
                                        id="customRadioDegraded4"
                                        name="bessMode"
                                        className="custom-control-input islandableRadio  asCompatible"
                                        checked={
                                          isBessOperatingMode === "NO_EXCHANGE"
                                        }
                                        onClick={exportManagementBessMode}
                                        value="NO_EXCHANGE"
                                      />
                                      <label
                                        className="custom-control-label line-height-25px"
                                        htmlFor="customRadioDegraded4"
                                      >
                                        NO EXCHANGE
                                      </label>
                                      <se-tooltip
                                        action={
                                          true
                                            ? isTouchDevice()
                                              ? "click"
                                              : "hover"
                                            : ""
                                        }
                                        position="right"
                                      >
                                        <se-icon
                                          option="raised"
                                          color="secondary"
                                          slot="tooltip"
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content>
                                          "BESS cannot charge from grid. It can
                                          only charge from PV production. BESS
                                          cannot discharge to grid"
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )} */}
                            {
                            // projectTypeValue !== "MGaaS IEC" &&
                            //   projectTypeValue !== "MGaaS ETO" &&
                               (
                                <div className="row">
                                  <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-2 ">
                                    <div className="custom-control custom-radio">
                                      <input
                                        type="radio"
                                        id="customRadioDegraded1"
                                        name="bessMode"
                                        className="custom-control-input islandableRadio  asCompatible"
                                        checked={
                                          isBessOperatingMode === "UNRESTRICTED"
                                        }
                                        onClick={exportManagementBessMode}
                                        value="UNRESTRICTED"
                                      />
                                      <label
                                        className="custom-control-label line-height-25px"
                                        htmlFor="customRadioDegraded1"
                                      >
                                        UNRESTRICTED
                                      </label>
                                      <se-tooltip
                                        action={
                                          true
                                            ? isTouchDevice()
                                              ? "click"
                                              : "hover"
                                            : ""
                                        }
                                        position="right"
                                      >
                                        <se-icon
                                          option="raised"
                                          color="secondary"
                                          slot="tooltip"
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content>
                                          "BESS can charge from grid and PV.
                                          BESS can discharge to grid"
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </div>
                                  </div>
                                  { (
                                    <>
                                      {false && <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-2 ">
                                        <div className="custom-control custom-radio">
                                          <input
                                            type="radio"
                                            id="customRadioDegraded2"
                                            name="bessMode"
                                            className="custom-control-input islandableRadio  asCompatible"
                                            checked={
                                              isBessOperatingMode ===
                                              "EXPORT_ONLY"
                                            }
                                            onClick={exportManagementBessMode}
                                            value="EXPORT_ONLY"
                                          />
                                          <label
                                            className="custom-control-label line-height-25px"
                                            htmlFor="customRadioDegraded2"
                                          >
                                            EXPORT ONLY
                                          </label>
                                          <se-tooltip
                                            action={
                                              true
                                                ? isTouchDevice()
                                                  ? "click"
                                                  : "hover"
                                                : ""
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              "BESS cannot charge from grid. It
                                              can only charge from PV
                                              production. BESS can discharge to
                                              grid"
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </div>
                                      </div>}
                                      <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-2 ">
                                        <div className="custom-control custom-radio">
                                          <input
                                            type="radio"
                                            id="customRadioDegraded3"
                                            className="custom-control-input islandableRadio  asCompatible"
                                            name="bessMode"
                                            checked={
                                              isBessOperatingMode ===
                                              "IMPORT_ONLY"
                                            }
                                            onClick={exportManagementBessMode}
                                            value="IMPORT_ONLY"
                                          />
                                          <label
                                            className="custom-control-label line-height-25px"
                                            htmlFor="customRadioDegraded3"
                                          >
                                            IMPORT ONLY
                                          </label>
                                          <se-tooltip
                                            action={
                                              true
                                                ? isTouchDevice()
                                                  ? "click"
                                                  : "hover"
                                                : ""
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              "BESS can charge from grid and PV.
                                              BESS cannot discharge to grid"
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </div>
                                      </div>
                                    { false && <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-2 ">
                                        <div className="custom-control custom-radio">
                                          <input
                                            type="radio"
                                            id="customRadioDegraded4"
                                            name="bessMode"
                                            className="custom-control-input islandableRadio  asCompatible"
                                            checked={
                                              isBessOperatingMode ===
                                              "NO_EXCHANGE"
                                            }
                                            onClick={exportManagementBessMode}
                                            value="NO_EXCHANGE"
                                          />
                                          <label
                                            className="custom-control-label line-height-25px"
                                            htmlFor="customRadioDegraded4"
                                          >
                                            NO EXCHANGE
                                          </label>
                                          <se-tooltip
                                            action={
                                              true
                                                ? isTouchDevice()
                                                  ? "click"
                                                  : "hover"
                                                : ""
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              "BESS cannot charge from grid. It
                                              can only charge from PV
                                              production. BESS cannot discharge
                                              to grid"
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </div>
                                      </div>}
                                    </>
                                  )}
                                </div>
                              )}
                          </div>
                        </div>
                      )}

                    {/* Limit Energy Import/Export (Based on EMA) */}
                    {gridSettings?.exportOptimization === true && (
                      <div
                        className="col-md-12"
                        label="Limit Import/Export"
                        status={configuredStatus.emConfiguredStatus}
                        displayStatus="1"
                        icon="notification_error_full_stroke"
                      >
                        <div
                          className={`col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-1 ${
                            siteCreated ||
                            projectStatusData?.projectStatus === "COMPLETED" ||
                            projectStatusData?.projectStatus ===
                              "COMPLETED_AND_SEND"
                              ? "se-block-disabled not-allowed"
                              : !UserScope.access.saveProgram
                              ? "se-block-disabled"
                              : ""
                          }`}
                        >
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-2">
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input asCompatible"
                                      name="limitEnergyImport"
                                      id="limitEnergyImport"
                                      value={limitImport}
                                      checked={limitImport}
                                      onChange={
                                        handleLimitExportImportOptimization
                                      }
                                    />
                                    <label
                                      className="custom-control-label line-height-25"
                                      htmlFor="limitEnergyImport"
                                    >
                                      Import Limitation
                                    </label>
                                    <se-tooltip
                                      action={
                                        true
                                          ? isTouchDevice()
                                            ? "click"
                                            : "hover"
                                          : ""
                                      }
                                      position="right"
                                    >
                                      <se-icon
                                        option="raised"
                                        color="secondary"
                                        slot="tooltip"
                                      >
                                        information_circle
                                      </se-icon>
                                      <se-tooltip-content>
                                        Limit energy importation from the grid,
                                        10 minutes time performance
                                      </se-tooltip-content>
                                    </se-tooltip>
                                  </div>
                                </div>
                              </div>

                              {limitImport === true && (
                                <div className="row pl-2">
                                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                                    <div className="form-group row">
                                      <label
                                        htmlFor="inputEmail1112"
                                        className="col-sm-6 col-form-label"
                                      >
                                        Targeted Max Import Power (kW)
                                        <span className="se-mandatory">*</span>
                                        <span className="se-block-enabled">
                                          <se-tooltip
                                            action={
                                              isTouchDevice()
                                                ? "click"
                                                : "hover"
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              {getTooltipDataImportPower()?.[0]}
                                              <br></br>
                                              {getTooltipDataImportPower()?.[2]}
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </span>
                                      </label>
                                      <div className="col-sm-6">
                                        <input
                                          id="inputEmail112"
                                          type="text"
                                          autoComplete="none"
                                          className="form-control form-control-md"
                                          name="maxLimitEnergyImportPower"
                                          placeholder="Targeted Max Import Power (kW)"
                                          maxLength="4"
                                          value={maxLimitEnergyImportPower}
                                          onChange={
                                            maxExportImportPowerChangeHandler
                                          }
                                        />
                                        {maxLimitEnergyImportPower?.toString() ===
                                          "" && (
                                          <div className="invalid-feedback-custom">
                                            Targeted Max Import Power (kW) is
                                            required.
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="form-group row">
                                      <label
                                        htmlFor="peakStartImportHysteresis"
                                        className="col-sm-6 col-form-label"
                                      >
                                        Peak import start hysteresis
                                        {/* <span className="se-mandatory">*</span> */}
                                        <span className="se-block-enabled">
                                          <se-tooltip
                                            action={
                                              isTouchDevice()
                                                ? "click"
                                                : "hover"
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              {
                                                tooltipData
                                                  ?.peakImportStartHysteresis
                                                  ?.data
                                              }
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </span>
                                      </label>
                                      <div className="col-sm-3 input-group">
                                        <div className="input-group">
                                          <input
                                            id="peakStartImportHysteresis1"
                                            type="text"
                                            autoComplete="none"
                                            className="form-control form-control-md"
                                            name="peakImportHysteresisStartPercentage"
                                            maxLength="3"
                                            value={
                                              peakImportHysteresis?.startHysteresisPercent
                                            }
                                            onChange={
                                              maxExportImportPowerChangeHandler
                                            }
                                          />

                                          <div
                                            className="input-group-append"
                                            style={{ height: "38px" }}
                                          >
                                            <span
                                              className="input-group-text"
                                              style={{ padding: "5px" }}
                                            >
                                              %
                                            </span>
                                          </div>
                                        </div>
                                        {peakImportHysteresis?.startHysteresisPercent ===
                                          "" && (
                                          <div className="invalid-feedback-custom">
                                            {" "}
                                            Should be 0 - 100
                                          </div>
                                        )}
                                      </div>
                                      <div
                                        className="col-sm-3 input-group"
                                        style={{ paddingLeft: "0px" }}
                                      >
                                        <input
                                          id="peakStartImportHysteresis2"
                                          type="text"
                                          autoComplete="none"
                                          className="form-control form-control-md"
                                          name="peakImportHysteresisStartKw"
                                          placeholder="kW"
                                          maxLength="4"
                                          value={
                                            peakImportHysteresis?.startHysteresisKw
                                          }
                                          // onChange={""}
                                          readonly
                                          disabled
                                        />
                                        <div
                                          className="input-group-append"
                                          style={{ height: "38px" }}
                                        >
                                          <span
                                            className="input-group-text"
                                            style={{ padding: "5px" }}
                                          >
                                            kW
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="form-group row">
                                      <label
                                        htmlFor="peakImportHysteresisStop"
                                        className="col-sm-6 col-form-label"
                                      >
                                        Peak import stop hysteresis
                                        {/* <span className="se-mandatory">*</span> */}
                                        <span className="se-block-enabled">
                                          <se-tooltip
                                            action={
                                              isTouchDevice()
                                                ? "click"
                                                : "hover"
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              {
                                                tooltipData
                                                  ?.peakImportStopHysteresis
                                                  ?.data
                                              }
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </span>
                                      </label>
                                      <div className="col-sm-3 ">
                                        <div className="input-group">
                                          <input
                                            id="peakImportHysteresisStopPercentage"
                                            type="text"
                                            autoComplete="none"
                                            className="form-control form-control-md"
                                            name="peakImportHysteresisStopPercentage"
                                            maxLength="3"
                                            value={
                                              peakImportHysteresis?.stopHysteresisPercent
                                            }
                                            onChange={
                                              maxExportImportPowerChangeHandler
                                            }
                                          />
                                          <div
                                            className="input-group-append"
                                            style={{ height: "38px" }}
                                          >
                                            <span
                                              className="input-group-text"
                                              style={{ padding: "5px" }}
                                            >
                                              %
                                            </span>
                                          </div>
                                        </div>
                                        {peakImportHysteresis?.stopHysteresisPercent ===
                                          "" && (
                                          <div className="invalid-feedback-custom">
                                            {" "}
                                            Should be 0 - 100
                                          </div>
                                        )}
                                      </div>
                                      <div
                                        className="col-sm-3 input-group"
                                        style={{ paddingLeft: "0px" }}
                                      >
                                        <input
                                          id="peakImportHysteresisStop2"
                                          type="text"
                                          autoComplete="none"
                                          className="form-control form-control-md"
                                          name="peakImportHysteresisStopKw"
                                          placeholder="kW"
                                          maxLength="4"
                                          value={
                                            peakImportHysteresis?.stopHysteresisKw
                                          }
                                          // onChange={""}
                                          readonly
                                          disabled
                                        />
                                        <div
                                          className="input-group-append"
                                          style={{ height: "38px" }}
                                        >
                                          <span
                                            className="input-group-text"
                                            style={{ padding: "5px" }}
                                          >
                                            kW
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            {
                              <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-2">
                                <div className="row">
                                  <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input asCompatible"
                                        name="limitEnergyExport"
                                        id="limitEnergyExport"
                                        value={limitExport}
                                        checked={limitExport}
                                        onChange={
                                          handleLimitExportImportOptimization
                                        }
                                      />
                                      <label
                                        className="custom-control-label line-height-25"
                                        htmlFor="limitEnergyExport"
                                      >
                                        Export limitation
                                      </label>
                                      <se-tooltip
                                        action={
                                          true
                                            ? isTouchDevice()
                                              ? "click"
                                              : "hover"
                                            : ""
                                        }
                                        position="right"
                                      >
                                        <se-icon
                                          option="raised"
                                          color="secondary"
                                          slot="tooltip"
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content>
                                          Limit energy export to the grid, 10
                                          minutes time performance
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </div>
                                  </div>
                                </div>
                                {limitExport === true && (
                                  <div className="row pl-2">
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                      <div className="form-group row">
                                        <label
                                          htmlFor="inputEmail111"
                                          className="col-sm-6 col-form-label"
                                        >
                                          Targeted Max Export Power (kW)
                                          <span className="se-mandatory">
                                            *
                                          </span>
                                          <span className="se-block-enabled">
                                            <se-tooltip
                                              action={
                                                isTouchDevice()
                                                  ? "click"
                                                  : "hover"
                                              }
                                              position="right"
                                            >
                                              <se-icon
                                                option="raised"
                                                color="secondary"
                                                slot="tooltip"
                                              >
                                                information_circle
                                              </se-icon>
                                              <se-tooltip-content>
                                                {
                                                  tooltipData
                                                    ?.limitEnergyExportTooltipData
                                                    ?.data
                                                }
                                              </se-tooltip-content>
                                            </se-tooltip>
                                          </span>
                                        </label>
                                        <div className="col-sm-6">
                                          <input
                                            type="text"
                                            autoComplete="none"
                                            className="form-control form-control-md"
                                            name="maxLimitEnergyExportPower"
                                            placeholder="Targeted Max Export Power (kW)"
                                            maxLength="4"
                                            value={maxExportPower}
                                            onChange={
                                              maxExportImportPowerChangeHandler
                                            }
                                          />
                                          {maxLimitEnergyExportPower?.toString() ===
                                            "" && (
                                            <div className="invalid-feedback-custom">
                                              Targeted Max Export Power (kW) is
                                              required.
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    )}
                    {/* Load Shedding */}
                    {((gridSettings?.exportOptimization === true && siteType === embLabels.GRID_CONNECTED) ||siteType === embLabels.ISLANDABLE) &&
                       <div
                        className="col-md-12"
                        label="Load Management"
                        status={configuredStatus.lsConfiguredStatus}
                        displayStatus={
                          [embLabels.ISLANDABLE].includes(siteType) ? "1"
                           : [ embLabels.GRID_CONNECTED].includes(siteType) && isGridSiteWithImportLimitationTrue ? "1" :
                          "0"
                        }
                        icon="notification_error_full_stroke"
                      >
                        <se-divider></se-divider>
                        <div className={`${
                              siteCreated ||( projectStatusData?.projectStatus === "COMPLETED" || projectStatusData?.projectStatus === "COMPLETED_AND_SEND")
                                ? "se-block-disabled not-allowed"
                                : !UserScope.access.saveProgram
                                ? "se-block-disabled"
                                : ""
                            }`}> <LoadShedding /></div>
                       
                      </div>
                    }
                    

                    {/* Real Time Export Control (EMO-M Based) */}
                    {gridSettings?.noExport === true ? (
                      <div
                        className="col-md-12"
                        label="Real Time Export Control (EMO-M Based)"
                        status={configuredStatus.emConfiguredStatus}
                        displayStatus="1"
                        icon="notification_error_full_stroke"
                      >
                        <div
                          className={`col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-1 ${
                            siteCreated ||
                            projectStatusData?.projectStatus === "COMPLETED" ||
                            projectStatusData?.projectStatus ===
                              "COMPLETED_AND_SEND"
                              ? "se-block-disabled not-allowed"
                              : !UserScope.access.saveProgram
                              ? "se-block-disabled"
                              : ""
                          }`}
                        >
                          <div className="dropdown-divider"></div>

                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                              <span className="bold">
                                Selected export management type:
                              </span>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-2 ">
                              <div className="custom-control custom-radio">
                                <input
                                  type="radio"
                                  id="customRadioEx2"
                                  name="noExport"
                                  className="custom-control-input islandableRadio  asCompatible"
                                  checked={gridSettings?.noExport}
                                  onClick={exportManagementChangeHandler}
                                  disabled={
                                    gridSettings?.noExport === true
                                      ? false
                                      : true
                                  }
                                />
                                <label
                                  className="custom-control-label line-height-25px"
                                  htmlFor="customRadioEx2"
                                >
                                  Export management real time
                                </label>
                              </div>
                            </div>
                            {/* don't delete this */}
                            {false &&
                              !(
                                siteType === embLabels.ISLANDABLE_GSX &&
                                architectureType === embLabels.PV_GENSET_ATS &&
                                gridSettings?.mode == "FUEL_SAVER"
                              ) && (
                                <div className="col-sm-5 col-md-5 col-lg-5 col-xl-5 mb-2 ">
                                  <div className="custom-control custom-radio">
                                    <input
                                      type="radio"
                                      id="customRadioEx1"
                                      name="exportOptimization"
                                      className="custom-control-input islandableRadio asCompatible"
                                      checked={gridSettings?.exportOptimization}
                                      onClick={exportManagementChangeHandler}
                                      style={
                                        siteType ===
                                          embLabels.PV_HYBRIDIZATION ||
                                        (siteType ===
                                          embLabels.ISLANDABLE_GSX &&
                                          architectureType ===
                                            embLabels.PV_GENSET_ATS)
                                          ? { cursor: "not-allowed" }
                                          : { cursor: "pointer" }
                                      }
                                      disabled={
                                        siteType ===
                                          embLabels.PV_HYBRIDIZATION ||
                                        (siteType ===
                                          embLabels.ISLANDABLE_GSX &&
                                          architectureType ===
                                            embLabels.PV_GENSET_ATS) ||
                                        gridSettings?.exportOptimization ===
                                          false
                                          ? true
                                          : false
                                      }
                                    />
                                    <label
                                      className="custom-control-label line-height-25px"
                                      htmlFor="customRadioEx1"
                                    >
                                      Export management predictive optimization
                                    </label>
                                  </div>
                                </div>
                              )}
                          </div>

                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                              <div className="form-group row">
                                <label
                                  htmlFor="inputEmail11"
                                  className="col-sm-3 col-form-label"
                                >
                                  Targeted Max Export Power (kW)
                                  <span className="se-mandatory">*</span>
                                  <span className="se-block-enabled">
                                    <se-tooltip
                                      action={
                                        isTouchDevice() ? "click" : "hover"
                                      }
                                      position="right"
                                    >
                                      <se-icon
                                        option="raised"
                                        color="secondary"
                                        slot="tooltip"
                                      >
                                        information_circle
                                      </se-icon>
                                      <se-tooltip-content>
                                        {
                                          tooltipData?.realTimeExportTooltipData
                                            ?.data
                                        }
                                      </se-tooltip-content>
                                    </se-tooltip>
                                  </span>
                                </label>
                                <div className="col-sm-5">
                                  <input
                                    type="text"
                                    autoComplete="none"
                                    className="form-control form-control-md"
                                    name="maxExportPower"
                                    placeholder="Targeted Max Export Power (kW)"
                                    maxLength="4"
                                    value={maxExportPower}
                                    onChange={maxExportImportPowerChangeHandler}
                                  />
                                  {maxExportPower.toString() === "" && (
                                    <div className="invalid-feedback-custom">
                                      Targeted Max Export Power (kW) is
                                      required.
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                              <span className="bold">
                                Select export management functions
                              </span>
                            </div>
                          </div>

                          {clientType === embLabels.GREENSTRUXURE_PROJECT &&
                          siteType === embLabels.ISLANDABLE_GSX &&
                          architectureType === embLabels.PV_GENSET_ATS &&
                          gridSettings?.mode === "FUEL_SAVER" ? (
                            <>
                              <div className="row">
                                <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input asCompatible"
                                      name="batteryBufferingExport"
                                      id="customControlValidation4"
                                      value={
                                        batteryDetails.batteryBufferingExport
                                      }
                                      checked={
                                        batteryDetails.batteryBufferingExport
                                      }
                                      disabled={
                                        siteType === embLabels.PV_HYBRIDIZATION
                                          ? true
                                          : batteryDetails.batteryBufferingStatus ===
                                              true &&
                                            (gridSettings?.noExport === true ||
                                              gridSettings?.exportOptimization ===
                                                true)
                                          ? false
                                          : true
                                      }
                                      style={
                                        siteType === embLabels.PV_HYBRIDIZATION
                                          ? //  ||
                                            //   (siteType === embLabels.ISLANDABLE_GSX &&
                                            //     architectureType === embLabels.PV_GENSET_ATS)
                                            { cursor: "not-allowed" }
                                          : { cursor: "pointer" }
                                      }
                                      onChange={
                                        true
                                          ? undefined
                                          : exportFunctionChangeHandler
                                      }
                                    />
                                    <label
                                      className="custom-control-label line-height-25"
                                      htmlFor="customControlValidation4"
                                    >
                                      Battery buffering
                                    </label>
                                    <span className="se-block-enabled">
                                      <se-tooltip
                                        action={
                                          [
                                            embLabels.ISLANDABLE,
                                            embLabels.GRID_CONNECTED,
                                          ].includes(siteType)
                                            ? isTouchDevice()
                                              ? "click"
                                              : "hover"
                                            : "hover"
                                        }
                                        position="right"
                                      >
                                        <se-icon
                                          option="raised"
                                          color="secondary"
                                          slot="tooltip"
                                          disabled={
                                            siteType ===
                                            embLabels.PV_HYBRIDIZATION
                                              ? //  ||
                                                //   (siteType === embLabels.ISLANDABLE_GSX &&
                                                //     architectureType ===
                                                //     embLabels.PV_GENSET_ATS)
                                                true
                                              : false
                                          }
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content>
                                          {tooltipData?.batteryBuffering?.data}
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input asCompatible"
                                      name="pvCurtailmentExport"
                                      id="customControlValidation21"
                                      value={pvCurtailmentExport}
                                      checked={pvCurtailmentExport}
                                      disabled={
                                        gridSettings?.noExport === true ||
                                        gridSettings?.exportOptimization === true
                                          ? false
                                          : true
                                      }
                                      onChange={exportFunctionChangeHandler}
                                    />
                                    <label
                                      className="custom-control-label line-height-25"
                                      htmlFor="customControlValidation21"
                                    >
                                      PV curtailment
                                    </label>
                                    <Tooltip
                                      position="right"
                                      iconColor="secondary"
                                      information={
                                        tooltipData?.pVCurtailment?.data
                                      }
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input asCompatible"
                                      name="utilityLSIEnable"
                                      id="customControlValidationE3"
                                      checked={utilityLSIEnable}
                                      disabled={
                                        gridSettings?.noExport === true ||
                                        gridSettings?.exportOptimization === true
                                          ? false
                                          : true
                                      }
                                      onChange={utilityLSIChangeHandler}
                                    />
                                    <label
                                      className="custom-control-label line-height-25"
                                      htmlFor="customControlValidationE3"
                                    >
                                      PV breakers opening
                                    </label>
                                    <Tooltip
                                      position="right"
                                      iconColor="secondary"
                                      information={
                                        tooltipData?.pVBreakersOpening?.data
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="row">
                                <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input asCompatible"
                                      name="batteryBufferingExport"
                                      id="customControlValidation4"
                                      checked={
                                        siteType ===
                                          embLabels.PV_HYBRIDIZATION ||
                                        (siteType ===
                                          embLabels.ISLANDABLE_GSX &&
                                          architectureType ===
                                            embLabels.PV_GENSET_ATS)
                                          ? false
                                          : batteryDetails.batteryBufferingExport
                                      }
                                      disabled={
                                        siteType === embLabels.PV_HYBRIDIZATION
                                          ? true
                                          : batteryDetails.batteryBufferingStatus ===
                                              true &&
                                            (gridSettings?.noExport === true ||
                                              gridSettings?.exportOptimization ===
                                                true)
                                          ? false
                                          : true
                                      }
                                      style={
                                        siteType ===
                                          embLabels.PV_HYBRIDIZATION ||
                                        (siteType ===
                                          embLabels.ISLANDABLE_GSX &&
                                          architectureType ===
                                            embLabels.PV_GENSET_ATS)
                                          ? { cursor: "not-allowed" }
                                          : { cursor: "pointer" }
                                      }
                                      onChange={
                                        true
                                          ? undefined
                                          : ["MGaaS IEC", "MGaaS ETO"].includes(
                                              projectKind?.projectTypeValue
                                            ) &&
                                            gridSettings?.spanishCodeRealTime
                                          ? undefined
                                          : exportFunctionChangeHandler
                                      }
                                    />
                                    <label
                                      className="custom-control-label line-height-25"
                                      htmlFor="customControlValidation4"
                                    >
                                      Battery buffering
                                    </label>

                                    <span className="se-block-enabled">
                                      <se-tooltip
                                        action={
                                          [
                                            embLabels.ISLANDABLE,
                                            embLabels.GRID_CONNECTED,
                                          ].includes(siteType)
                                            ? isTouchDevice()
                                              ? "click"
                                              : "hover"
                                            : "hover"
                                        }
                                        position="right"
                                      >
                                        <se-icon
                                          option="raised"
                                          color="secondary"
                                          slot="tooltip"
                                          disabled={
                                            siteType ===
                                              embLabels.PV_HYBRIDIZATION ||
                                            (siteType ===
                                              embLabels.ISLANDABLE_GSX &&
                                              architectureType ===
                                                embLabels.PV_GENSET_ATS)
                                              ? true
                                              : false
                                          }
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content>
                                          {tooltipData?.batteryBuffering?.data}
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              {!(
                                clientType ===
                                  embLabels.GREENSTRUXURE_PROJECT &&
                                siteType === embLabels.GRID_CONNECTED_GSX &&
                                architectureType === embLabels.PV_BESS_NR
                              ) && (
                                <div className="row">
                                  <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input asCompatible"
                                        name="lossOfComm"
                                        id="isBessCBsMotorizedOrContactor"
                                        value={lossOfComm}
                                        checked={lossOfComm}
                                        disabled={
                                          gridSettings?.noExport === true ||
                                          gridSettings?.exportOptimization ===
                                            true
                                            ? isRealTimeExportConfg === true
                                              ? true
                                              : false
                                            : true
                                        }
                                        onChange={
                                          ["MGaaS IEC", "MGaaS ETO"].includes(
                                            projectKind?.projectTypeValue
                                          ) && gridSettings?.spanishCodeRealTime
                                            ? undefined
                                            : exportFunctionChangeHandler
                                        }
                                      />
                                      <label
                                        className="custom-control-label line-height-25"
                                        htmlFor="isBessCBsMotorizedOrContactor"
                                      >
                                        Open BESS/PV breaker in case of loss of
                                        communication
                                      </label>
                                      <se-tooltip
                                        action={
                                          isTouchDevice() ? "click" : "hover"
                                        }
                                        position="right"
                                      >
                                        <se-icon
                                          option="raised"
                                          color="secondary"
                                          slot="tooltip"
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content>
                                          {isMotorizedOrContactor?.isBessCBsMotorizedOrContactor ===
                                          false ? (
                                            "To be able to ensure circuit breaker operation, please update DER configuration by adding motor mechanism or circuit breaker to PV branches and/or BESS branches"
                                          ) : (
                                            <dl style={{ width: "285px" }}>
                                              <dt>EMO-M will :</dt>
                                              <dd>
                                                - Open Battery breaker in case
                                                of loss of communication with
                                                Utility meter.
                                              </dd>
                                              <dd>
                                                - Open PV breaker in case of
                                                loss of communication with
                                                Utility meter/PV inverter.
                                              </dd>
                                            </dl>
                                          )}
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div className="row">
                                <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input asCompatible"
                                      name="pvCurtailmentExport"
                                      id="customControlValidation22"
                                      value={pvCurtailmentExport}
                                      checked={pvCurtailmentExport}
                                      disabled={
                                        gridSettings?.noExport === true ||
                                        gridSettings?.exportOptimization === true
                                          ? false
                                          : true
                                      }
                                      onChange={
                                        ["MGaaS IEC", "MGaaS ETO"].includes(
                                          projectKind?.projectTypeValue
                                        ) && gridSettings?.spanishCodeRealTime
                                          ? undefined
                                          : exportFunctionChangeHandler
                                      }
                                    />
                                    <label
                                      className="custom-control-label line-height-25"
                                      htmlFor="customControlValidation22"
                                    >
                                      PV curtailment
                                    </label>
                                    <Tooltip
                                      position="right"
                                      iconColor="secondary"
                                      information={
                                        tooltipData?.pVCurtailment?.data
                                      }
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input asCompatible"
                                      name="utilityLSIEnable"
                                      id="isBessCBsMotorizedOrContactor"
                                      checked={utilityLSIEnable}
                                      disabled={
                                        gridSettings?.spanishCodeRealTime ===
                                        true
                                          ? true
                                          : gridSettings?.noExport === true ||
                                            gridSettings?.exportOptimization ===
                                              true
                                          ? isRealTimeExportConfg === true
                                            ? true
                                            : false
                                          : true
                                      }
                                      onChange={utilityLSIChangeHandler}
                                    />
                                    <label
                                      className="custom-control-label line-height-25"
                                      htmlFor="isBessCBsMotorizedOrContactor"
                                    >
                                      PV breakers opening
                                    </label>
                                    <Tooltip
                                      position="right"
                                      iconColor="secondary"
                                      information={
                                        isMotorizedOrContactor?.isBessCBsMotorizedOrContactor ===
                                        false
                                          ? "To be able to ensure circuit breaker operation, please update DER configuration by adding motor mechanism or circuit breaker to PV branches and/or BESS branches"
                                          : tooltipData?.pVBreakersOpening?.data
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          )}

                          {((clientType === embLabels.GREENSTRUXURE_PROJECT &&
                            siteType === embLabels.GRID_CONNECTED_GSX &&
                            architectureType === embLabels.PV_BESS_NR) ||
                            (clientType === embLabels.GREENSTRUXURE_PROJECT &&
                              siteType === embLabels.ISLANDABLE_GSX &&
                              architectureType ===
                                embLabels.PV_GENSET_ATS)) && (
                            <div className="row">
                              <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input asCompatible"
                                    name="lossOfComm"
                                    id="customControlValidation23"
                                    value={lossOfComm}
                                    checked={lossOfComm}
                                    disabled={
                                      gridSettings?.noExport === true ||
                                      gridSettings?.exportOptimization === true
                                        ? false
                                        : true
                                    }
                                    onChange={exportFunctionChangeHandler}
                                  />
                                  <label
                                    className="custom-control-label line-height-25"
                                    htmlFor="customControlValidation23"
                                  >
                                    Degraded Mode
                                  </label>
                                  <Tooltip
                                    position="right"
                                    iconColor="secondary"
                                    information=" If EMA controller disconnected from EMO-M
                                  then charge the BESS to nominal state of
                                  charge. Export excess of PV Production to
                                  grid when BESS already charged to nominal."
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div
                        className="col-md-12"
                        label="Real Time Export Control"
                        status="1"
                        displayStatus="0"
                        icon="notification_error_full_stroke"
                      ></div>
                    )}

                    {/* Real Time Import Control (EMA Controller Based) */}
                    {false && gridSettings?.noImport === true && (
                      <div
                        className="col-md-12"
                        label="Real Time Import Control (EMA Controller Based)"
                        status={configuredStatus.realTimeControlEMA}
                        displayStatus="1"
                        icon="notification_error_full_stroke"
                      >
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-1">
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                              <div className="form-group row">
                                <label
                                  htmlFor="inputEmail113"
                                  className="col-sm-3 col-form-label"
                                >
                                  Import Start Hysteresis
                                  <span className="se-mandatory">*</span>
                                  <span className="se-block-enabled">
                                    <se-tooltip
                                      action={
                                        isTouchDevice() ? "click" : "hover"
                                      }
                                      position="right"
                                    >
                                      <se-icon
                                        option="raised"
                                        color="secondary"
                                        slot="tooltip"
                                      >
                                        information_circle
                                      </se-icon>
                                      <se-tooltip-content>
                                        {
                                          tooltipData
                                            ?.importStartHysteresisTooltipData
                                            ?.data
                                        }
                                      </se-tooltip-content>
                                    </se-tooltip>
                                  </span>
                                </label>
                                <div className="col-sm-5">
                                  <input
                                    type="text"
                                    autoComplete="none"
                                    className="form-control form-control-md"
                                    name="importStartHysteresis"
                                    placeholder="Targeted Start Hysteresis"
                                    maxLength="4"
                                    value={importStartHysteresis}
                                    onChange={hysteresisChangeHandler}
                                  />
                                  {importStartHysteresis?.toString() === "" ? (
                                    <div className="invalid-feedback-custom">
                                      Targeted Import Start Hysteresis is
                                      required.
                                    </div>
                                  ) : parseInt(importStartHysteresis) <= 1000 &&
                                    parseInt(importStartHysteresis) >= 0 ? (
                                    parseInt(importStartHysteresis) >=
                                    parseInt(importStopHysteresis) ? (
                                      <div className="invalid-feedback-custom">
                                        Targeted Import Start Hysteresis should
                                        be less than Import Stop Hysteresis
                                      </div>
                                    ) : (
                                      ""
                                    )
                                  ) : (
                                    <div className="invalid-feedback-custom">
                                      Targeted Import Start Hysteresis should be
                                      in range (0 &lt; Max Import Start
                                      Hysteresis &gt; 1000)
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                              <div className="form-group row">
                                <label
                                  htmlFor="inputEmail113"
                                  className="col-sm-3 col-form-label"
                                >
                                  Import Stop Hysteresis
                                  <span className="se-mandatory">*</span>
                                  <span className="se-block-enabled">
                                    <se-tooltip
                                      action={
                                        isTouchDevice() ? "click" : "hover"
                                      }
                                      position="right"
                                    >
                                      <se-icon
                                        option="raised"
                                        color="secondary"
                                        slot="tooltip"
                                      >
                                        information_circle
                                      </se-icon>
                                      <se-tooltip-content>
                                        {
                                          tooltipData
                                            ?.importStopHysteresisTooltipData
                                            ?.data
                                        }
                                      </se-tooltip-content>
                                    </se-tooltip>
                                  </span>
                                </label>
                                <div className="col-sm-5">
                                  <input
                                    id="inputEmail113"
                                    type="text"
                                    autoComplete="none"
                                    className="form-control form-control-md"
                                    name="importStopHysteresis"
                                    placeholder="Targeted import Stop Hysteresis"
                                    maxLength="4"
                                    value={importStopHysteresis}
                                    onChange={hysteresisChangeHandler}
                                  />
                                  {importStopHysteresis?.toString() === "" ? (
                                    <div className="invalid-feedback-custom">
                                      Targeted Max Import Power (kW) is
                                      required.
                                    </div>
                                  ) : parseInt(importStopHysteresis) <= 1000 &&
                                    parseInt(importStopHysteresis) >= 0 ? (
                                    parseInt(importStopHysteresis) >
                                    parseInt(importStartHysteresis) ? (
                                      ""
                                    ) : (
                                      <div className="invalid-feedback-custom">
                                        Targeted Import Stop Hysteresis value
                                        should be greater than Import Start
                                        Hysteresis
                                      </div>
                                    )
                                  ) : (
                                    <div className="invalid-feedback-custom">
                                      Targeted Import Stop Hysteresis should be
                                      in range (0 &lt; Max Import Stop
                                      Hysteresis &gt; 1000)
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Manual Demand Response  */}
                    {gridSettings?.manualDemandResponse === true ? (
                      <div
                        className="col-md-12"
                        label="Manual Demand Response"
                        status={1}
                        displayStatus="1"
                        icon="notification_error_full_stroke"
                      >
                        <div className="row pt-2 pl-4">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 pl-4 se-block-disabled">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input asCompatible"
                                name="manualDemandResponse"
                                id="manualDemandResponse"
                                value={gridSettings?.manualDemandResponse}
                                checked={gridSettings?.manualDemandResponse}
                                onChange={
                                  gridSettings?.manualDemandResponse === true
                                    ? undefined
                                    : undefined
                                }
                              />
                              <label
                                className="custom-control-label line-height-25"
                                htmlFor="manualDemandResponse"
                              >
                                Enabled
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="col-md-12"
                        label="dummy Manual Demand Response"
                        status="1"
                        displayStatus="0"
                        icon="notification_error_full_stroke"
                      ></div>
                    )}

                    {/* Electrical Vehicle Energy Management  */}
                    {gridSettings?.electricalVehicleEnergyManagement ===
                    true ? (
                      <div
                        className="col-md-12"
                        label="Electrical Vehicle Energy Management"
                        status={1}
                        displayStatus="1"
                        icon="notification_error_full_stroke"
                      >
                        <div className="row pt-2 pl-4">
                          <div
                            className={`col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-1 ${
                              siteCreated ||
                              projectStatusData?.projectStatus ===
                                "COMPLETED" ||
                              projectStatusData?.projectStatus ===
                                "COMPLETED_AND_SEND"
                                ? "se-block-disabled not-allowed"
                                : !UserScope.access.saveProgram
                                ? "se-block-disabled"
                                : ""
                            }`}
                          >
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input asCompatible"
                                name="electricalVehicleEnergyManagement"
                                id="electricalVehicleEnergyManagement"
                                value={
                                  eVceData?.isElectricalVehicleEnergyManagement
                                }
                                checked={
                                  eVceData?.isElectricalVehicleEnergyManagement
                                }
                                onChange={undefined}
                              />
                              <label
                                className="custom-control-label line-height-25"
                                htmlFor="electricalVehicleEnergyManagement"
                              >
                                Enabled
                              </label>
                            </div>
                          </div>
                          {eVceData?.isElectricalVehicleEnergyManagement && (
                            <div
                              className={`col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-2 ${
                                siteCreated ||
                                projectStatusData?.projectStatus ===
                                  "COMPLETED" ||
                                projectStatusData?.projectStatus ===
                                  "COMPLETED_AND_SEND"
                                  ? "se-block-disabled not-allowed"
                                  : !UserScope.access.saveProgram
                                  ? "se-block-disabled"
                                  : ""
                              }`}
                            >
                              <div className="form-group row">
                                <label
                                  htmlFor="webServiceURL"
                                  className="col-sm-5 col-form-label"
                                >
                                  Webservice URL
                                </label>
                                <div className="col-sm-6">
                                  <input
                                    id="webServiceURL"
                                    type="text"
                                    autoComplete="none"
                                    className="form-control form-control-md"
                                    name="webServiceURL"
                                    placeholder="e.g. http://xxx.xxx.xx/"
                                    value={eVceData?.webServiceURL}
                                    onChange={handleEVCE}
                                  />
                                </div>
                              </div>
                              <div className="form-group row">
                                <label
                                  htmlFor=" numberOfZones"
                                  className="col-sm-5 col-form-label"
                                >
                                  Number of Zones
                                </label>
                                <div className="col-sm-6">
                                  <input
                                    id="numberOfZones"
                                    type="text"
                                    autoComplete="none"
                                    className="form-control form-control-md"
                                    name="noOfZones"
                                    placeholder="e.g. 1,2,3,..."
                                    disabled="true"
                                    value={eVceData?.noOfZones}
                                    onChange={true ? undefined : handleEVCE}
                                  />
                                </div>
                              </div>
                              <div className="form-group row">
                                <label
                                  htmlFor=" componentId"
                                  className="col-sm-5 col-form-label"
                                >
                                  Component ID
                                </label>
                                <div className="col-sm-6">
                                  <input
                                    id="componentId"
                                    type="text"
                                    autoComplete="none"
                                    className="form-control form-control-md"
                                    name="componentIds"
                                    placeholder="e.g. EVCE1, EVCE2,..."
                                    disabled="true"
                                    value={eVceData?.componentIds}
                                    onChange={true ? undefined : handleEVCE}
                                  />
                                </div>
                              </div>
                              <div className="form-group row">
                                <label
                                  htmlFor="evMaxAllowedPower"
                                  className="col-sm-5 col-form-label"
                                >
                                  EV Max Allowed Power (kW)
                                  <span className="se-block-enabled">
                                    <se-tooltip
                                      action={
                                        isTouchDevice() ? "click" : "hover"
                                      }
                                      position="right"
                                    >
                                      <se-icon
                                        option="raised"
                                        color="secondary"
                                        slot="tooltip"
                                      >
                                        information_circle
                                      </se-icon>
                                      <se-tooltip-content>
                                        {tooltipData?.evcemaxPower?.data}
                                      </se-tooltip-content>
                                    </se-tooltip>
                                  </span>
                                </label>
                                <div className="col-sm-6">
                                  <input
                                    id="evMaxAllowedPower"
                                    type="text"
                                    autoComplete="none"
                                    className="form-control form-control-md"
                                    name="evMaxAllowedPower"
                                    placeholder="kW"
                                    disabled="true"
                                    value={evMaxAllowedPower}
                                    onChange={true ? undefined : handleEVCE}
                                  />
                                </div>
                              </div>
                              <div className="form-group row">
                                <label
                                  htmlFor="onPeakPowerLimit"
                                  className="col-sm-5 col-form-label"
                                >
                                  High Tariff Power Limit (kW)
                                  <span className="se-block-enabled">
                                    <se-tooltip
                                      action={
                                        isTouchDevice() ? "click" : "hover"
                                      }
                                      position="right"
                                    >
                                      <se-icon
                                        option="raised"
                                        color="secondary"
                                        slot="tooltip"
                                      >
                                        information_circle
                                      </se-icon>
                                      <se-tooltip-content>
                                        {tooltipData?.powerLimit?.data}
                                      </se-tooltip-content>
                                    </se-tooltip>
                                  </span>
                                </label>
                                <div className="col-sm-6">
                                  <input
                                    id="onPeakPowerLimit"
                                    type="text"
                                    autoComplete="none"
                                    className="form-control form-control-md"
                                    name="onPeakPowerLimit"
                                    placeholder="kW"
                                    value={eVceData?.onPeakPowerLimit}
                                    onChange={handleEVCE}
                                    disabled={evMaxAllowedPower === 0 ? true : false}
                                  />
                                </div>
                              </div>
                              <div className="form-group row">
                                <label
                                  htmlFor="highTariffCurtailment"
                                  className="col-sm-5 col-form-label"
                                >
                                  High Tariff Curtailment (%)
                                  <span className="se-block-enabled">
                                    <se-tooltip
                                      action={
                                        isTouchDevice() ? "click" : "hover"
                                      }
                                      position="right"
                                    >
                                      <se-icon
                                        option="raised"
                                        color="secondary"
                                        slot="tooltip"
                                      >
                                        information_circle
                                      </se-icon>
                                      <se-tooltip-content>
                                        {
                                          tooltipData?.highTariffCurtailment
                                            ?.data
                                        }
                                      </se-tooltip-content>
                                    </se-tooltip>
                                  </span>
                                </label>
                                <div className="col-sm-6">
                                  <input
                                    id="highTariffCurtailment"
                                    type="text"
                                    autoComplete="none"
                                    className="form-control form-control-md"
                                    name="highTariffCurtailment"
                                    placeholder="%"
                                    disabled="true"
                                    value={eVceData?.highTariffCurtailment}
                                    onChange={handleEVCE}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div
                        className="col-md-12"
                        label="Electrical Vehicle Energy Management"
                        status="1"
                        displayStatus="0"
                        icon="notification_error_full_stroke"
                      ></div>
                    )}

                    {/* offGridMode Response  */}
                    {gridSettings?.offGridMode === true ? (
                      <div
                        className="col-md-12"
                        label="Off Grid Preparedness"
                        status={1}
                        displayStatus="1"
                        icon="notification_error_full_stroke"
                      >
                        <div className="row pt-2 pl-4">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 pl-4 se-block-disabled">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input asCompatible"
                                name="selfConsumption"
                                id="customControlValidation3"
                                value={gridSettings?.offGridMode}
                                checked={gridSettings?.offGridMode}
                                onChange={
                                  gridSettings?.offGridMode === true
                                    ? undefined
                                    : undefined
                                }
                              />
                              <label
                                className="custom-control-label line-height-25"
                                htmlFor="customControlValidation3"
                              >
                                Enabled
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="col-md-12"
                        label="dummy Off Grid Preparedness"
                        status="1"
                        displayStatus="0"
                        icon="notification_error_full_stroke"
                      ></div>
                    )}

                    {/* selfConsumption */}
                    {gridSettings?.selfConsumption === true &&
                    (projectTypeValue !== "DaaS ANSI" ||
                      projectTypeValue !== "DaaS ETO") ? (
                      <div
                        className="col-md-12"
                        label="Self Consumption"
                        status={1}
                        displayStatus="1"
                        icon="notification_error_full_stroke"
                      >
                        <div className="row pt-2 pl-4">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 pl-4 se-block-disabled">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input asCompatible"
                                name="selfConsumption"
                                id="customControlValidation3"
                                value={gridSettings?.selfConsumption}
                                checked={gridSettings?.selfConsumption}
                                onChange={
                                  gridSettings?.selfConsumption === true
                                    ? undefined
                                    : undefined
                                }
                              />
                              <label
                                className="custom-control-label line-height-25"
                                htmlFor="customControlValidation3"
                              >
                                Enabled
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="col-md-12"
                        label="dummy Self Consumption"
                        status="1"
                        displayStatus="0"
                        icon="notification_error_full_stroke"
                      ></div>
                    )}

                    {/* Outage mode preparation*/}
                    {gridSettings?.stormPreparedness === true ? (
                      <div
                        className="col-md-12"
                        label="Outage mode preparation"
                        status={1}
                        displayStatus="1"
                        icon="notification_error_full_stroke"
                      >
                        <div className="row pt-2 pl-4">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 pl-4 se-block-disabled">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input asCompatible"
                                name="Outage mode preparation"
                                id="stormPreparedness1"
                                value={gridSettings?.stormPreparedness}
                                checked={gridSettings?.stormPreparedness}
                                onChange={
                                  gridSettings?.stormPreparedness === true
                                    ? undefined
                                    : undefined
                                }
                              />
                              <label
                                className="custom-control-label line-height-25"
                                htmlFor="stormPreparedness1"
                              >
                                Enabled
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="col-md-12"
                        label="dummy Outage mode preparation"
                        status="1"
                        displayStatus="0"
                        icon="notification_error_full_stroke"
                      ></div>
                    )}

                    {/* Green Consumption */}
                    {gridSettings?.greenConsumption === true &&
                    projectTypeValue === "MGaaS ANSI" ? (
                      <div
                        className="col-md-12"
                        label="Green Consumption"
                        status={1}
                        displayStatus="1"
                        icon="notification_error_full_stroke"
                      >
                        <div className="row pt-2 pl-4">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 pl-4 se-block-disabled">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input asCompatible"
                                name="Green Consumption"
                                id="greenConsumption1"
                                value={gridSettings?.greenConsumption}
                                checked={gridSettings?.greenConsumption}
                                onChange={
                                  gridSettings?.greenConsumption === true
                                    ? undefined
                                    : undefined
                                }
                              />
                              <label
                                className="custom-control-label line-height-25"
                                htmlFor="greenConsumption1"
                              >
                                Enabled
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="col-md-12"
                        label="dummy Green Consumption"
                        status="1"
                        displayStatus="0"
                        icon="notification_error_full_stroke"
                      ></div>
                    )}
                    {/* Net Metering */}
                    {false &&
                    gridSettings?.netMetering === true &&
                    projectTypeValue === "MGaaS ANSI" ? (
                      <div
                        className="col-md-12"
                        label="Net Metering "
                        status={1}
                        displayStatus="1"
                        icon="notification_error_full_stroke"
                      >
                        <div className="row pt-2 pl-4">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 pl-4 se-block-disabled">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input asCompatible"
                                name="Net Metering"
                                id="netMetering"
                                value={gridSettings?.netMetering}
                                checked={gridSettings?.netMetering}
                                onChange={
                                  gridSettings?.netMetering === true
                                    ? undefined
                                    : undefined
                                }
                              />
                              <label
                                className="custom-control-label line-height-25"
                                htmlFor="netMetering1"
                              >
                                Enabled
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="col-md-12"
                        label="dummy Storm Preparation"
                        status="1"
                        displayStatus="0"
                        icon="notification_error_full_stroke"
                      ></div>
                    )}
                    <div
                      className="col-md-12"
                      label="dummy on grid"
                      status={1}
                      displayStatus="0"
                      icon="notification_error_full_stroke"
                    ></div>
                    {gridSettings?.specificMonitoring === true &&
                    projectTypeValue === "MGaaS ANSI" ? (
                      <div
                        className="col-md-12"
                        label="Specific Monitoring"
                        status={1}
                        displayStatus="1"
                        icon="notification_error_full_stroke"
                      >
                        <div className="row pt-2 pl-4">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 pl-4 se-block-disabled">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input asCompatible"
                                name="Specific Monitoring"
                                id="specificMonitoring"
                                value={gridSettings?.specificMonitoring}
                                checked={gridSettings?.specificMonitoring}
                                onChange={()=>{}}
                              />
                              <label
                                className="custom-control-label line-height-25"
                                htmlFor="specificMonitoring"
                              >
                                Enabled
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="col-md-12"
                        label="dummy Specific Monitoring"
                        status="1"
                        displayStatus="0"
                        icon="notification_error_full_stroke"
                      ></div>
                    )}
                    {gridSettings?.antiIslandingDetection === true &&
                    ["MGaaS IEC", "MGaaS ANSI", "MGaaS ETO"].includes(
                      projectTypeValue
                    ) ? (
                      <div
                        className="col-md-12"
                        label="Anti Islanding Detection"
                        status={1}
                        displayStatus="1"
                        icon="notification_error_full_stroke"
                      >
                        <div className="row pt-2 pl-4">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 pl-4 se-block-disabled">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input asCompatible"
                                name="Anti Islanding Detection"
                                id="antiIslanding"
                                value={gridSettings?.antiIslandingDetection}
                                checked={gridSettings?.antiIslandingDetection}
                                onChange={
                                  gridSettings?.specificMonitoring === true
                                    ? undefined
                                    : undefined
                                }
                              />
                              <label
                                className="custom-control-label line-height-25"
                                htmlFor="antiIslanding"
                              >
                                Enabled
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="col-md-12"
                        label="dummy Anti Islanding"
                        status="1"
                        displayStatus="0"
                        icon="notification_error_full_stroke"
                      ></div>
                    )}
                  </Accordion>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {
        <div className={`row se-white-background pb-2`}>
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-2 ">
            <span className="se-font-14px-bold se-life-green ">
              Metering Priority
            </span>

            <div className="row ">
              {
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <Accordion allowMultipleOpen>
                    <div
                      className="col-md-12"
                      label="dummy on grid"
                      status={1}
                      displayStatus="0"
                      icon="notification_error_full_stroke"
                    ></div>
                    {
                      <div
                        className="col-md-12"
                        label=" Metering Priority"
                        status={1}
                        displayStatus="1"
                        icon="notification_error_full_stroke"
                      >
                        <div
                          className={`row ${
                            siteCreated ||
                            projectStatusData?.projectStatus === "COMPLETED" ||
                            projectStatusData?.projectStatus ===
                              "COMPLETED_AND_SEND"
                              ? "se-block-disabled"
                              : !UserScope.access.saveProgram
                              ? "se-block-disabled"
                              : ""
                          }`}
                        >
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 ">
                            <DevicePriority />
                          </div>
                        </div>
                      </div>
                    }
                  </Accordion>
                </div>
              }
            </div>
          </div>
        </div>
      }
      <se-dialog
        id="AlertDialog"
        open={alertPopup.alertPopUpStatus}
        can-backdrop="false"
      >
        <se-dialog-header>{alertPopup.title}</se-dialog-header>
        <se-dialog-content
          icon="information_circle"
          color="primary"
          className="se-header-font-size-16px se-life-green"
        >
          {alertPopup.message}
        </se-dialog-content>
        <se-dialog-footer>
          <se-button onClick={closeAlertPopup}>OK</se-button>
        </se-dialog-footer>
      </se-dialog>
    </>
  );
};

export default OnGridOptimization;
